import { firestore } from '~/firebase/init';
import { doc, onSnapshot } from 'firebase/firestore';
import { SnapshotFn } from './type';

export function enterpriseGroupBuyDataListener(enterpriseGroupBuyId: string, onNext: SnapshotFn) {
  const ref = doc(firestore, 'enterpriseGroupBuy', enterpriseGroupBuyId);

  return onSnapshot(ref, {
    next: onNext,
    error: (err) => {
      console.error('enterpriseCartListener error', err);
    },
  });
}
